import store from '@/store';
import axios from "axios";

import {logoutApi, refresh, refreshApi} from "@/api/auth";
import {sleep} from "@/utils";
import router from "@/router";

export let isRefreshRunning = false;

let delayedApiCallList = [];

function commonRequestInterceptors(config) {
	config.headers['ACCESS-TOKEN'] = store.getters['token/ACCESS_TOKEN'];
	config.headers['REFRESH-TOKEN'] = store.getters['token/REFRESH_TOKEN'];

	store.commit('startJobs');

	return config;
}

function commonRequestErrorInterceptors(error) {
	store.commit('finishJobs');
	return error;
}

function commonResponseInterceptors(response) {
	store.commit('finishJobs');
	return response;
}

const authResponseErrorInterceptors = async (error) => {
	store.commit('finishJobs');
	const {config} = error;
	const {url} = config;

	if(url !== '/auth/logout') {
		delayedApiCallList = [];
		await logoutApi();
	}
	return error.response;
}

const apiResponseErrorInterceptors = async (error) => {
	store.commit('finishJobs');
	const { config, response: { status } } = error;

	if(status === 401) {
		await logoutApi();
	}else if(status === 405){
		alert('해당 요청에 대한 권한이 부족합니다.');
		await router.push({path: '/home'});
	}else if(status === 403) {
		if(config.headers['RETRY']){
			await logoutApi();
			return error.response;
		}
		if(!isRefreshRunning) {
			delayedApiCallList = [];
			isRefreshRunning = true;

			let refreshSuccess = await refresh();

			isRefreshRunning = false;

			if(!refreshSuccess) {
				delayedApiCallList = [];
				await logoutApi();
			}else {
				await sleep(10);

				delayedApiCallList.map(callback => callback())

				config.headers['ACCESS-TOKEN'] = store.getters['token/ACCESS_TOKEN'];
				config.headers['REFRESH-TOKEN'] = store.getters['token/REFRESH_TOKEN'];
				config.headers['RETRY'] = true;

				store.commit('startJobs');
				return axios(config).catch(apiResponseErrorInterceptors).finally(()=>store.commit('finishJobs'));
			}
		}else {
			return new Promise((resolve) => {
				delayedApiCallList.push(() => {
					config.headers['ACCESS-TOKEN'] = store.getters['token/ACCESS_TOKEN'];
					config.headers['REFRESH-TOKEN'] = store.getters['token/REFRESH_TOKEN'];
					config.headers['RETRY'] = true;
					store.commit('startJobs');
					resolve(axios(config).catch(apiResponseErrorInterceptors).finally(()=>store.commit('finishJobs')));
				});
			});
		}
	}
	return error.response;
}

const auth = axios.create({timeout: 30000});
auth.defaults.baseURL = process.env.VUE_APP_AUTH_URL;
auth.interceptors.request.use(commonRequestInterceptors, commonRequestErrorInterceptors);
auth.interceptors.response.use(commonResponseInterceptors, authResponseErrorInterceptors);

const api = axios.create({timeout: 30000});
api.defaults.baseURL = process.env.VUE_APP_API_URL;
api.interceptors.request.use(commonRequestInterceptors, commonRequestErrorInterceptors);
api.interceptors.response.use(commonResponseInterceptors, apiResponseErrorInterceptors);

const stats = axios.create({timeout : 300000});
stats.defaults.baseURL = process.env.VUE_APP_API_URL;
stats.interceptors.request.use(commonRequestInterceptors, commonRequestErrorInterceptors);
stats.interceptors.response.use(commonResponseInterceptors, apiResponseErrorInterceptors);

export {auth, api, stats}